export default {
    init() {
        this.initSendFilters();
        this.initTimeEdits();
        this.initDateTimePickers();
        this.initTimeSave();
    },
    updateTimeManagementTable() {
        let $this = this;
        if ($('#time_management_table').length) {
            $.ajax({
                type: 'POST',
                url: '/manage_time_filter',
                data: ({
                    phone: $('select[name="phone"]').val(),
                    start_date: $('input[name="start_date"]').val(),
                    end_date: $('input[name="end_date"]').val(),
                    search: $('input[name="search"]').val(),
                    count: $('select[name="count"]').val(),
                    page: $('input#page_top').val(),
                }),
                success: function (response) {
                    $('#time_management_table').html(response);
                    $this.initDateTimePickers();
                }
            });
        }
    },
    initSendFilters() {
        let $this = this;
        $('body').on('focusout', '.manage-time-filter', function (e) {
            e.preventDefault();
            $this.updateTimeManagementTable();
        });
    },
    initTimeEdits() {
        let $this = this;
        $('body').on('click', '.time-edit', function (event) {
            $('.edit-time-form-wrapper .form-validation-errors').html('');
            event.preventDefault();
            event.stopPropagation();
            $.ajax({
                type: 'GET',
                url: '/manage_time_get',
                data: ({
                    id: $(this).data('id'),
                }),
                success: function (response) {
                    let item = response.time;
                    if (item) {
                        $('#edit-time-form input[name="id"]').val(item.id);
                        $('#edit-time-form input[name="time_in"]').val(item.in);
                        $('#edit-time-form input[name="time_out"]').val(item.out);
                        $this.changeHoursWorked(item.minutes);
                        $('#edit-time-modal').modal('show');

                        $('#time_in').datetimepicker({
                            defaultDate: new Date(item.in),
                            format: 'YYYY-MM-DD HH:mm:ss',
                        });
                        $('#time_out').datetimepicker({
                            defaultDate: new Date(item.out),
                            format: 'YYYY-MM-DD HH:mm:ss',
                        });
                        $("#time_in").on("dp.change", function () {
                            let diff = new Date($('#time_out').val()) - new Date($('#time_in').val());
                            $this.changeHoursWorked(Math.round(diff / 60000));
                        });
                        $("#time_out").on("dp.change", function () {
                            let diff = new Date($('#time_out').val()) - new Date($('#time_in').val());
                            $this.changeHoursWorked(Math.round(diff / 60000));
                        });
                    }
                }
            });
        });
    },
    initTimeSave() {
        $('body').on('click', '#edit-time-submit-form', function () {
            let hours = parseInt($('#edit-time-form .hours_worked').text());
            let minutes = parseInt($('#edit-time-form .minutes_worked').text());
            if (minutes) {
                minutes += (hours * 60);
            } else {
                minutes = hours * 60;
            }
            let page = window.location.pathname;
            let data = $('#edit-time-form').serialize() +
                '&' + $('#time-management-filters').serialize() +
                '&minutes=' + minutes + '&page=' + page;
            $.ajax({
                type: 'POST',
                url: '/manage_time_save',
                data: data,
                success: function (response) {
                    $('#edit-time-modal').modal('hide');
                    $('body').removeClass('modal-open').css('padding-right', 0);
                    $('.modal-backdrop').remove();
                    $('#edit-time-form')[0].reset();
                    $('.edit-time-form-wrapper .form-validation-errors').empty();
                    if (page === '/dashboard') {
                        $('#dashboard .time-management-table').html(response.data.times_table);
                    } else {
                        $('#time_management_table').html(response.view);
                    }
                },
                error: function (response) {
                    if (response.responseJSON.error) {
                        $('.edit-time-form-wrapper .form-validation-errors').html('<div class="alert alert-danger">' + response.responseJSON.error + '</div>');
                    }
                    if (response.responseJSON.errors) {
                        let errorsHtml = '<div class="alert alert-danger">Some errors occurred:<br /><ul>';

                        $.each(response.responseJSON.errors, function (index, value) {
                            errorsHtml += '<li>' + value + '</li>';
                        });
                        errorsHtml += '</ul></div>';

                        $('.edit-time-form-wrapper .form-validation-errors').html(errorsHtml);
                    }
                }
            });
        })
    },
    initDateTimePickers() {
        $('#range_date').daterangepicker();
        $('#start_date').datetimepicker();
        $('#end_date').datetimepicker({
            useCurrent: false,
        });
        $("#start_date").on("dp.change", function (e) {
            $('#end_date').data("DateTimePicker").minDate(e.date);
        });
        $("#end_date").on("dp.change", function (e) {
            $('#start_date').data("DateTimePicker").maxDate(e.date);
        });
    },
    changeHoursWorked($minutes) {
        let minutes = $minutes;
        let hours = parseInt(minutes / 60);
        minutes = minutes - hours * 60;
        $('#edit-time-form .hours_worked').html(hours + 'h');
        if (minutes > 0) {
            $('#edit-time-form .minutes_worked').html(minutes + 'm');
        } else {
            $('#edit-time-form .minutes_worked').html('');
        }
    }
}
